<template>
  <b-modal
    ref="modalRef"
    id="edit-site-modal"
    :title="title"
    @ok.prevent="onSubmit"
  >
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form @submit.stop.prevent="handleSubmit(onSubmit)">
        <validation-provider
          name="Name"
          :rules="{ required: true, domainName: true }"
          v-slot="validationContext"
        >
          <b-form-group
            label-cols="4"
            label-align="rignt"
            :label="$t('edit-site.domain')"
            label-for="domain"
          >
            <b-form-input
              v-model="site.domainName"
              :state="getValidationState(validationContext)"
              id="domain"
            ></b-form-input>
          </b-form-group>
        </validation-provider>

        <validation-provider
          Name="IP"
          :rules="{ required: false, ipv4v6: true }"
          v-slot="validationContext"
        >
          <b-form-group
            :label="$t('edit-site.ip')"
            label-for="ip"
            label-cols="4"
            label-align="rignt"
          >
            <b-form-input
              v-model="site.ip"
              :state="getValidationState(validationContext)"
              id="domain"
            ></b-form-input>
          </b-form-group>
        </validation-provider>

        <validation-provider
          name="Port"
          :rules="{
            required: false,
            min_value: 0,
            max_value: 65535,
            integer: true
          }"
          v-slot="validationContext"
        >
          <b-form-group
            :label="$t('edit-site.port')"
            label-for="port"
            label-cols="4"
            label-align="rignt"
          >
            <b-form-input
              v-model.number="site.port"
              placeholder="443"
              type="number"
              :state="getValidationState(validationContext)"
              id="domain"
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-form>
    </validation-observer>

    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button :disabled="loading" @click="ok()">
        <b-spinner small v-if="loading"></b-spinner>
        {{ $t("base.ok") }}
      </b-button>
      <b-button @click="cancel()">
        {{ $t("base.cancel") }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "EditSite",
  data() {
    return {
      site: {
        domainName: "",
        port: 443,
        ip: ""
      },
      loading: false,
      title: ""
    };
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    show(site) {
      this.site = site || {};
      this.$bvModal.show("edit-site-modal");
      if (this._.isEmpty(site)) {
        this.title = this.$t("edit-site.create-site");
      } else {
        this.title = this.$t("edit-site.edit-site");
      }
    },
    onSubmit() {
      this.$refs.observer.validate().then(async success => {
        if (!success) {
          return;
        }

        this.loading = true;
        const res = await this.$api.sites.createSite({
          domainName: this.site.domainName.trim(),
          port: this.site.port,
          ip: this.site.ip?.trim()
        });
        this.loading = false;

        if (res.data.success) {
          this.$emit("refresh");
          this.$refs.modalRef.hide();
        }
      });
    }
  }
};
</script>
